import { SearchIcon } from "@heroicons/react/solid";
import Tooltip from "rc-tooltip";
import React, { useState } from "react";
import QuickSearchModal from "./QuickSearchModal";

interface Props {
  className?: string;
}

const QuickSearchButton: React.FC<Props> = ({ className }) => {
  const [showModal, setShowModal] = useState(false);

  const onClose = () => setShowModal(false);

  return (
    <div className={className}>
      <Tooltip placement="bottom" overlay="Quick search">
        <button
          type="button"
          className="h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none dark:text-gray-200 dark:hover:text-white"
          onClick={() => setShowModal(true)}
        >
          <SearchIcon className="h-6 w-6" />
        </button>
      </Tooltip>

      {showModal && <QuickSearchModal onClose={onClose} />}
    </div>
  );
};

export default QuickSearchButton;
